export default {
  title: "The Metalloobrabotka Gravity 2026 Competition",
  greeting: "Dear exhibitors of Metalloobrabotka 2026,",
  intro: {
    paragraph1:
      "Your active participation in attracting an audience to your stand is the foundation of our mutual success.",
    paragraph2:
      "Wide information coverage increases the likelihood for each participant to find new customers, strengthen partnerships, and conclude profitable deals. After all, promotion efforts work not only for the general interest in the event, but also directly increase the return on your company's participation in the show.",
    highlight:
      "We appreciate your contribution and invite you to celebrate it within the Metalloobrabotka Gravity 2026 Competition!"
  },
  howItWorks: {
    title: "How it works",
    content:
      "Use a unique UTM tag from your Personal Account in your communications: on the website, in social media, email newsletters, and when working with partners. Each ticket received using your unique UTM tag increases your chances of winning and makes RosBuild even more effective for your business. On the last day of the show, the organiser summarizes the results, and the three companies whose UTM tags have received the largest number of tickets receive prizes."
  },
  prizes: {
    title: "Prizes for winners",
    first: {
      badge: "1st place",
      title: "Grand Prize",
      items: [
        "The title of Metalloobrabotka Gravity 2026",
        "Honorary certificate",
        "Yandex.Station 3 smart speaker"
      ],
      subtitle:
        "The 1st place is taken by the participant who attracted the largest number of visitors but no less than 300 people"
    },
    second: {
      badge: "2nd place",
      title: "Second place",
      items: ["Honorary certificate", "Yandex.Station Midi smart speaker"],
      subtitle:
        "The 2nd place is awarded to the participant who attracted the second highest number of visitors, but no less than 200 people"
    },
    third: {
      badge: "3rd place",
      title: "Third place",
      items: ["Honorary certificate", "Yandex.Station Mini smart speaker"],
      subtitle:
        "The 3rd place is awarded to the participant who attracted the third highest number of visitors, but no less than 100 people"
    },
    subtitle:
      "In the case of attracting an equal number of visitors, the winner is the company that first achieved these indicators."
  },
  closing: {
    paragraph1:
      "And most importantly, your activity will help fill the stands with interested professional visitors, which will be the best reward for all participants.",
    downloadBanner: "Download banner",
    highlight:
      "Let's create the most productive event in the metalworking industry together!"
  },
  info: {
    datesLabel: "The dates of the competition:",
    datesValue: "1 April – 15 May 2026",
    resultsLabel: "The date of summing up the results of the Competition:",
    resultsValue: "15 May 2026"
  },
  motto: "You work for your success. We support your efforts.",
  agreement: {
    termsPrefix:
      "I have read and fully agree to the terms and conditions of the ",
    termsLink: "Regulations of the Metalloobrabotka Gravity 2026 Competition",
    termsUrl: "/static/docs/contest/REGULATIONS_ENG.pdf",
    termsSuffix: ".",
    rules:
      "I accept the rules for determining winners based on data from the analytics system and commit to using only permitted methods to attract visitors."
  },
  button: {
    loading: "Getting link...",
    getLink: "Get link",
    participate: "Participate in the competition"
  },
  noContest: {
    title: "No active competitions",
    text:
      "There are currently no competitions for participants. Follow updates in your Personal Account.",
    button: "Back"
  },
  successPopup: {
    title: "Link copied!",
    text: "You can use link for:",
    item1: "Posting on website or social media",
    item2: "Using in email newsletters",
    copy: "Copy the link"
  }
};
